export class ChampLibreGroup {

  public champsLibre: string[];

  constructor() {
    this.champsLibre = [];

  }
}
